import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Avatar, Box, Button, Divider, Fab, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useAuth } from '../../hooks/useAuth';
import { makeStyles } from '@mui/styles';
import { NotificationManager } from 'react-notifications';
import DeleteIcon from '@mui/icons-material/Delete';
import { deletedInbox, setInbox } from '../../services/material-services';
import { CssTextField } from '../layout/elements';
import ReplyIcon from '@mui/icons-material/Reply';

const useStyles = makeStyles( theme => ({
    header_dtl: {
        fontFamily: 'Segoe UI',
        marginRight: '10px',
        marginTop: '10px',
        color: theme.mainAccentColor
    },
    memberContainer:{
      display: 'grid',
      gridTemplateColumns: '100px auto'
    },
    image_cover:{
        height:500, 
        width:'100%', 
        paddingLeft: '-2rem',
        paddingRight: '-1rem',
    }
}))


function SendInbox() {
    
    const { authData, authDataLang } = useAuth()
    // const [isAdmin, setIsAdmin] = useState(false)
    const [statusReq, setStatusReq ] = useState(false)

    const location = useLocation()
    const { state } = location

    const [ image, setImage ] = useState(null)
    const [ imageSelect, setImageSelect ] = useState(null)
    
    const [remarks, setRemarks ] = useState('')
    const [title, setTitle ] = useState('')
    const [msgID, setMsgID ] = useState(0)


    const cssClass = useStyles()
    // const navigate = useNavigate()
    
    
    useEffect(() => {
        window.scrollTo(0, 0)
        // if(authData?.user){
        //     setIsAdmin(authData.user.profile?.is_permium)
        // }
        if (state != null){
            // console.log(location)
            setStatusReq(true)
            if (state.id){
                setMsgID(state.id)
            }

            if (state.name){
                setTitle(state.title)
            }
            if (state.remarks){
                setRemarks(state.remarks)
            }
            if (state.image){
                setImage(state.image)
            }
        }

    }, [state])

    const onSelectFile = e => {
        if (!e.target.files || e.target.files.length === 0) {
            setImageSelect(undefined)
            return
        }

        // setImage(e.target.files[0])
        // I've kept this example simple by using the first image instead of multiple
        setImageSelect(e.target.files[0])
        // console.log(e.target.files[0])
        setImage(URL.createObjectURL(e.target.files[0]))
    }

    const handelSubmitImage = async e => {
        e.preventDefault()
        const uploaddata = new FormData()
        if(imageSelect){
            uploaddata.append('image', imageSelect, imageSelect.name)
        }
        uploaddata.append('id', msgID)
        uploaddata.append('title', title)
        uploaddata.append('remarks', remarks)

        const addNewMaterial = await setInbox(authData?.token, uploaddata)
        // console.log(addNewMaterial)
        if (addNewMaterial){
            NotificationManager.success('پیام ارسال شد')
        }else{
            NotificationManager.error('متاسفانه خطایی در زمان ارسال پیام وجود دارد')
        }
        // await uploadImageMaterial(matID, uploaddata)
    }
    
    const submitDelete = async e =>{
        const delMaterial = await deletedInbox(authData?.token, {'msg_id' : msgID})
        if (delMaterial){
            NotificationManager.success('پیام با موفقیت حذف شد')
        }else{
            NotificationManager.error('متاسفانه خطایی در زمان حذف پیام وجود دارد')
        }

    }

  return (
    <React.Fragment>
    <div style={{minHeight: 1000}} dir={authDataLang?.view_sts ? "rtl" : "ltr"}>
        <br/>
        <Link to={'/my-inbox'}>
            <Avatar >
                <ReplyIcon color='primary' sx={{ fontSize: 40}}/>
            </Avatar>    
        </Link>
        <div style={{display: 'grid', gridTemplateColumns: '1fr 10rem'}}>
            <h1 className={cssClass.header_dtl}>{authDataLang?.site_langs?.desc_menu_msg_send}</h1>
            <Divider />
            {statusReq &&
                <Fab variant="extended" 
                    size="small" color="secondary" 
                    aria-label="add" 
                    sx={{
                        textAlign: 'right',
                        fontFamily: 'b_mitra',
                    }}
                    onClick={submitDelete}
                    >
                    <DeleteIcon sx={{ mr: 1 }} />
                    <Typography
                        fontFamily='b_mitra' 
                        component="div"
                        variant="h6"
                        >
                        حذف
                    </Typography>
                    
                </Fab>
            }
        </div>        
        <hr/>
        <Box 
            sx={{
                p: 2,
                bgcolor: '#E7EBF0',
                display: 'block',
                gap: 2,
                width: '100%',
                marginRight: 'auto',
                marginLeft: 'auto',
                textAlign: 'left',
              }}
            >
            <Paper elevation={3} sx={{
                display: 'block',
                marginRight: 'auto',
                marginLeft: 'auto',
                textAlign: 'right',
                }} >

                <form onSubmit={handelSubmitImage}>
                    <div style={{textAlign: 'right', marginRight: 20}}>
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item>
                                <input
                                    accept="image/*"
                                    style={{ display: 'none', width: '100%', height: '100%' }}
                                    id="raised-button-file"
                                    multiple
                                    type="file"
                                    onChange={onSelectFile}
                                />
                                <label htmlFor="raised-button-file">
                                    <Button variant="raised" component="span" >
                                        <Avatar sx={{width: '200px', height: '100px'}}
                                            src={image} />
                                    </Button>
                                </label>
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item>
                                <AccountCircle sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item sx={{width:'90%'}}>
                                <CssTextField label={authDataLang?.site_langs?.desc_header} 
                                    sx={{fontFamily: 'b_mitra', fontSize: 24}}
                                    fullWidth
                                    variant="standard" value={title}
                                    onChange={ e => setTitle( e.target.value )} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item sx={{marginTop: '1fr', marginBottom: 'auto',}}>
                                <AccountCircle sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item sx={{width: '90%'}}>
                                <CssTextField label={authDataLang?.site_langs?.desc_description} 
                                    sx={{fontFamily: 'b_mitra', fontSize: 24}}
                                    multiline
                                    fullWidth
                                    rows={4} 
                                    className={cssClass.header_dtl}
                                    variant="standard" value={remarks}
                                    onChange={ e => setRemarks( e.target.value )} />
                            </Grid>
                        </Grid>
                    </div>
                    <Divider />
                    
                    <br/>
                                
                    <Button sx={{fontFamily: 'b_mitra', fontSize: 24}} variant="contained" color="primary" type='submit'
                        disabled={!title || !remarks}>
                        {authDataLang?.site_langs?.desc_buttom_accept}
                    </Button>
                </form>
            </Paper>
        </Box>
    </div>
    </React.Fragment>
  )
}

export default SendInbox
